import { render, staticRenderFns } from "./helpIndex.vue?vue&type=template&id=46a948d4"
import script from "./helpIndex.vue?vue&type=script&lang=js"
export * from "./helpIndex.vue?vue&type=script&lang=js"
import style0 from "./helpIndex.vue?vue&type=style&index=0&id=46a948d4&prod&lang=css"
import style1 from "./helpIndex.vue?vue&type=style&index=1&id=46a948d4&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports